import React from "react";
import "./Evaluation.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp, faStar } from "@fortawesome/free-solid-svg-icons";
import useEvaluation from "./useEvaluation";
import { getRating } from "../../../../_helpers/getRating";

export default (props) => {
  const { userPrimarySkills } = useEvaluation(props);

  return (
    <div className="evaluation-wrapper h-100">
      <div className="card-body border-radius-10 border  bg-white">
        <ul className="d-flex align-items-center flex-wrap">
          {Array.isArray(userPrimarySkills) && userPrimarySkills?.length ? (
            <>
              {Array.isArray(userPrimarySkills) &&
                userPrimarySkills?.map((skill) => (
                  <>
                    <li className="font-weight-normal mr-2 d-flex align-items-center text-nowrap pl-3 pr-1 py-1 fs-14 border rounded-pill bg-grey-3 mb-2">
                      <span className="d-inline-block  text-capitalize">
                        {skill?.skill_name}
                      </span>
                      <span className="d-inline-block custom-tag tag-offer bg-white px-3 ml-2 py-1 rounded-pill">
                        {skill?.rating}
                      </span>
                    </li>
                  </>
                ))}
            </>
          ) : (
            <>
              <h3 className="text-danger p-3 text-center">No Skills</h3>
            </>
          )}
        </ul>
        {userPrimarySkills && userPrimarySkills.length ? (
        <span className="custom-pills completed fs-14 d-inline-flex align-items-center font-weight-medium  rounded-pill mt-4 py-1 pr-3 pl-1">
          <span className="custom-pills completed p-2 rounded-pill bg-white mr-2"><FontAwesomeIcon className="mr-2" icon={faArrowUp} />
          {getRating(userPrimarySkills)}
          </span>
           Average score
        </span>
      ) : null}
      </div>
    </div>
  );
};
